import { constants } from "../constants/redux-constants";

export const set_person_details = (payload) => { return { type: constants.SET_PERSON_DATA, payload } }
export const set_related_persons_details = (payload) => { return { type: constants.RELATED_PERSONS_DATA, payload } }
export const set_active_person_id = (payload) => { return { type: constants.ACTIVE_PERSON_ID, payload } }
export const set_current_user_setting = (payload) => {return {type: constants.SET_CURRENT_USER_SETTINGS, payload} }
